const PUFFS = [
  { left: "4%", delay: "0s", duration: "26s" },
  { left: "26%", delay: "-9s", duration: "32s" },
  { left: "48%", delay: "-17s", duration: "28s" },
  { left: "68%", delay: "-4s", duration: "34s" },
  { left: "86%", delay: "-22s", duration: "30s" },
];

export const Steam = () => (
  <div className="steam-layer" aria-hidden="true">
    {PUFFS.map((p, i) => (
      <span
        key={i}
        className="steam-puff"
        style={{ left: p.left, animationDelay: p.delay, animationDuration: p.duration }}
      />
    ))}
  </div>
);
